<template>
    <Badge
        class="inline-flex"
        :color="entityWithPaymentState.getPaymentStateBadgeColor()"
    >
        {{ entityWithPaymentState.getPaymentStateBadgeLabel() }}
    </Badge>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Badge from '@/Shared/Component/Badge.vue'
    import type HasPaymentStateInterface from '@/App/Booking/Shared/Entity/HasPaymentStateInterface'

    const props = defineProps({
        entityWithPaymentState: {
            type: Object as PropType<HasPaymentStateInterface>,
            required: true,
        },
    })
</script>
